const data = {
  /************ ENGLISH **************/
  en: {
    slogan1: "Dedicated Doctors",
    slogan2: "High-quality Services",
    slogan3: "Affordable Prices",
    homepage: "Home",
    price: "Price",
    about: "About",
    map: "Contact Infos",
    mainService: "Main Services",
    mainService1: "Tooth extraction & Fillings",
    mainService2: "Root Canal Treatment",
    mainService3: "Dentures",
    mainService4: "",
    workingTime1: "Working Hours",
    shift1: "Day",
    shift2: "Night",
    shift3: "Closed",
    day1: "Monday",
    day2: "Tuesday",
    day3: "Wednesday",
    day4: "Thursday",
    day5: "Friday",
    day6: "Saturday",
    day7: "Sunday",
    address: "Address",
    realAddress: "204 Thong Nhat Street, Ward 11, Go Vap District, Ho Chi Minh City",
    contact: "Contacts",
    phoneNum1: "Appointment Number: 028 6286 9045",
    phoneNum2: "Doctor Number: 0913 895 695",
    email: "Email: nhakhoamyduchcm@gmail.com",
    name: "My Duc Dental",
    FAQ: "Help & FAQs",
    account: "My Account",
    language: "Language",
    nameDoctor1: "Dr. Nguyen Thi Le Chi",
    titleDoctor1: "Dentist & Director",
    descriptionDoctor1:
      "As the founder of My Duc Dental, Dr. Chi has more than 20 years of experience in the field of dentistry which allows her to guide other doctors efficiently to provide the best dental care services for you dear customers.",
    nameDoctor2: "Dr. Nguyen Thi My",
    titleDoctor2: "Dentist",
    descriptionDoctor2:
      "Our professional team of doctors will ensure you have the most comfortable experience, offering free consultations and examinations to help you choose the perfect service tailored to your needs.",
    description1:
      "With over 10 years of experience in the dental field, My Duc Dental is one of the best dental clinics in Ho Chi Minh City, where you can find the best dental care services at prices suitable for every family.",
    description2:
      "Our professional team of doctors will ensure you have the most comfortable experience, offering free consultations and examinations to help you choose the perfect service tailored to your needs.",
    description3:
      "Since 2010, our dental clinic has been the exclusive provider officially recognized by the Intellectual Property Office under the 'My Duc Dental' brand. With over a decade of achievements in the medical field, we are dedicated to delivering you the highest quality services available.",
    motto: "Your Smile Is Our Greatest Pride!",
    titleIntroduction1: "About Us",
    titleIntroduction2: "Our Services",
    descriptionIntroduction1:
      "With over 10 years of experience in the dental field, My Duc Dental is one of the best dental clinics in Ho Chi Minh City, where you can find the best dental care services at prices suitable for every family.",
    descriptionIntroduction2:
      "Our professional team of doctors will ensure you have the most comfortable experience, offering free consultations and examinations to help you choose the perfect service tailored to your needs.",
    login: "Login",
    loginEmail: "Email",
    password: "Mật khẩu",   
    signup: "Sign Up",
    enterEmail: "example@domain.com",
    enterPassword: "Enter your password",
    loginSuccess: "Login successful!",
    loginFailed: "Login failed",
    registrationSuccess: "Registration successful! You can now log in.",
    registrationFailed: "Registration failed",
    loginError: "An error occurred while logging in.",
    registrationError: "An error occurred while registering.",
    loadingMessage:
      "Processing, please wait... It will take 1-2 minutes if you have not used the app for a while.",
    addClientFormNote:
      "*Note: After updating a field, please wait until the page is updated or the notification is shown (if the server is inactive for 1h, it will sleep, so it will take 1-2 minutes to update the next time).",
  },
  /************ Vietnamese **************/
  vn: {
    slogan1: "Bác sĩ tận tình",
    slogan2: "Dịch vụ chất lượng",
    slogan3: "Giá cả hợp lí",
    homepage: "Trang Chủ",
    price: "Bảng Giá",
    about: "Giới Thiệu",
    map: "Thông Tin Liên Lạc",
    mainService: "Dịch vụ chính",
    mainService1: "Nhổ & trám răng",
    mainService2: "Chữa tủy",
    mainService3: "Trồng răng giả",
    mainService4: "",
    workingTime1: "Thời gian làm việc",
    shift1: "Sáng",
    shift2: "Chiều",
    shift3: "Nghỉ",
    day1: "Thứ 2",
    day2: "Thứ 3",
    day3: "Thứ 4",
    day4: "Thứ 5",
    day5: "Thứ 6",
    day6: "Thứ 7",
    day7: "Chủ Nhật",
    address: "Địa chỉ",
    realAddress:
      "204 Thống Nhất, Phường 11, quận Gò Vấp, TP. Hồ Chí Minh",
    contact: "Thông tin liên lạc",
    phoneNum1: "SĐT đặt lịch: 028 6286 9045",
    phoneNum2: "SĐT bác sĩ: 0913 895 695",
    email: "Email: nhakhoamyduchcm@gmail.com",
    name: "Nha Khoa Mỹ Đức",
    FAQ: "Trợ Giúp",
    account: "Tài khoản",
    language: "Ngôn ngữ",
    vietnamese: "Vietnamese",
    nameDoctor1: "Bác sĩ Nguyễn Thị Lệ Chi",
    titleDoctor1: "Bác sĩ chuyên khoa & Giám đốc",
    descriptionDoctor1:
      "Là người thành lập nha khoa Mỹ Đức, bác sĩ Chi đã có trong mình hơn 20 năm kinh nghiệm chuyên môn để luôn sẵn sàng hướng dẫn các bác sĩ & phụ tá khác mang đến những dịch vụ chăm sóc răng miệng tốt nhất cho quý khách.",
    nameDoctor2: "Bác sĩ Nguyễn Thị Mỹ",
    titleDoctor2: "Bác sĩ nha khoa",
    descriptionDoctor2:
      "Đội ngũ bác sĩ chuyên nghiệp của chúng tôi sẽ đem đến cho quý khách những trải nghiệm nhẹ nhàng và chu đáo nhất Đồng thời, quý khách sẽ được tư vấn và khám bệnh miễn phí để quý khách có thể chọn lựa dịch vụ phù hợp với bản thân nhất.",
    description1:
      "Với hơn 10 năm kinh nghiệm trong ngành răng hàm mặt, nha khoa Mỹ Đức là một trong những nha khoa với những dịch vụ tốt nhất ở thành phố Hồ Chí Minh - nơi quý khách có thể tìm thấy những dịch vụ chăm sóc răng miệng tốt nhất với giá cả phù hợp với mọi gia đình.",
    description2:
      "Đội ngũ bác sĩ chuyên nghiệp của chúng tôi sẽ đem đến cho quý khách trải nghiệm thoái mái nhất, đồng thời quý khách sẽ được tư vấn và khám bệnh miễn phí để quý khách có thể chọn lựa dịch vụ phù hợp với bản thân nhất.",
    description3:
      "Từ năm 2010, nha khoa chúng tôi đã được cục sở hữu trí tuệ công nhận là doanh nghiệp hợp lệ duy nhất dưới thương hiệu 'Nha khoa Mỹ Đức', cùng với những thành tựu trong lĩnh vực y khoa mà chúng tôi đã đạt được trong hơn 10 năm thành lập sẽ giúp chúng tôi cung cấp cho quý khách những dịch vụ hoàn hảo nhất.",
    motto: "Nụ Cười Của Bạn Chính Là Niềm Vinh Dự Của Chúng Tôi!",
    titleMeetOurDoctors: "Danh Sách Bác Sĩ",
    titleIntroduction1: "Giới thiệu",
    titleIntroduction2: "Dịch vụ",
    descriptionIntroduction1:
      "Với hơn 10 năm kinh nghiệm trong ngành răng hàm mặt, nha khoa Mỹ Đức là nơi quý khách có thể tìm thấy những dịch vụ chăm sóc răng miệng tốt nhất với giá cả phù hợp với mọi gia đình.",
    descriptionIntroduction2:
      "Đội ngũ bác sĩ chuyên nghiệp của chúng tôi sẽ đem đến cho quý khách những trải nghiệm nhẹ nhàng và chu đáo cùng với dịch vụ tư vấn và khám bệnh miễn phí để quý khách có thể chọn lựa dịch vụ phù hợp với bản thân nhất.",
    login: "Đăng nhập",
    loginEmail: "Email",
    password: "Mật khẩu",
    signup: "Đăng ký",
    enterEmail: "example@domain.com",
    enterPassword: "Nhập mật khẩu của bạn",
    loginSuccess: "Đăng nhập thành công!",
    loginFailed: "Đăng nhập thất bại",
    registrationSuccess:
      "Đăng ký thành công! Bạn có thể đăng nhập ngay bây giờ.",
    registrationFailed: "Đăng ký thất bại",
    loginError: "Đã xảy ra lỗi khi đăng nhập.",
    registrationError: "Đã xảy ra lỗi khi đăng ký.",
    loadingMessage:
      "Đang thực hiện, vui lòng đợi... Sẽ mất 1-2 phút nếu bạn chưa sử dụng ứng dụng trong một thời gian.",
    addClientFormNote:
      "*Lưu ý: Sau khi cập nhật thông tin, vui lòng đợi cho đến khi thông tin đó được cập nhật trên bảng (nếu ko hoạt động trong 1h thì server sẽ ngủ, nên sẽ mất 1-2 phút để server hoạt động lại).",
  },
};

export default data;
